import { VISA_TYPES, VISA_ENTRY_TYPES } from "./bookingConstants";
import s from "./VisaForm.module.css";

const VisaForm = ({ form, f }) => (
  <>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#fef3c7", color: "#d97706" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
        </div>
        <span className={s.formCardTitle}>Visa Information</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Visa Type</label><select className={s.input} value={form.visaType} onChange={e=>f("visaType",e.target.value)}><option value="">Select...</option>{VISA_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
          <div className={s.field}><label className={s.fieldLabel}>Country</label><input className={s.input} value={form.visaCountry} onChange={e=>f("visaCountry",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Entry Type</label><select className={s.input} value={form.visaEntryType} onChange={e=>f("visaEntryType",e.target.value)}><option value="">Select...</option>{VISA_ENTRY_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
        </div>
      </div>
    </div>
    <div className={s.formCard}>
      <div className={s.formCardHeader}>
        <div className={s.formCardIcon} style={{ background: "#eff6ff", color: "#2563eb" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        </div>
        <span className={s.formCardTitle}>Validity</span>
      </div>
      <div className={s.formCardBody}>
        <div className={s.mfRow3}>
          <div className={s.field}><label className={s.fieldLabel}>Issue Date</label><input className={s.input} type="date" value={form.visaIssueDate} onChange={e=>f("visaIssueDate",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Expiry Date</label><input className={s.input} type="date" value={form.visaExpiryDate} onChange={e=>f("visaExpiryDate",e.target.value)}/></div>
          <div className={s.field}><label className={s.fieldLabel}>Duration of Stay</label><input className={s.input} placeholder="e.g. 90 days" value={form.visaDurationOfStay} onChange={e=>f("visaDurationOfStay",e.target.value)}/></div>
        </div>
      </div>
    </div>
  </>
);

export default VisaForm;
